import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ReservationDetailRequest, ReservationModel } from '../_models/Reservation/ReservationModel';
import { Operations } from "../_models/Reservation/ReservationStatus";

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  reservationsChanged = new Subject<ReservationModel[]>();

  private reservations: ReservationModel[] = [];
  private currentEventId: string;
  private status: Operations;

  constructor() { }

  getReservations() {
    return this.reservations.slice();
  }

  getCurrentEventId() {
    return this.currentEventId;
  }

  getCurrentStatus() {
    return this.status;
  }

  //not using at the moment
  getReservation(index: number) {
    return this.reservations[index];
  }

  //not using at the moment
  addReservation(reservation: ReservationModel) {
    this.reservations.push(reservation)
    this.reservationsChanged.next(this.reservations.slice());
  }
  //for Update not using at the moment
  setReservations(reservations: ReservationModel[], eventId: string, status: Operations, concat?: boolean) {
    this.currentEventId = eventId;
    this.status = status !== Operations.WaitingApprovalChanged ? status : Operations.WaitingApproval;

    reservations.forEach((element: ReservationModel) => {
      this.formateDate(element);
    });

    if (concat === true) {
      this.reservations = this.reservations.concat(reservations);
    } else {
      this.reservations = reservations;
    }

    this.reservationsChanged.next(this.reservations.slice());
  }

  //not using at the moment
  deleteReservation(index: number) {
    this.reservations.splice(index, 1);
    this.reservationsChanged.next(this.reservations.slice());
  }

  // setEventValues(event: EventModelRequest) {
  //   const formData = new FormData();
  //   formData.append('Name', event.Name as string)
  //   formData.append('Description', event.Description as string)
  //   formData.append('Title', event.Title as string)
  //   formData.append('StartDateTime', event.StartDateTime as string)
  //   formData.append('StartTime', event.StartTime as string)
  //   formData.append('EndDateTime', event.EndDateTime as string)
  //   formData.append('VenueId', event.VenueId as string)
  //   formData.append('MaximumCapacity', String(event.MaxCapacity))
  //   formData.append('PictureUrl', event.PictureUrl as string)
  //   if(event.EventTypesIds != undefined){
  //     for(let i = 0; i < event.EventTypesIds.length; i++) {
  //       formData.append("EventTypesIds", event.EventTypesIds[i])
  //     }
  //   }
  //   return formData;
  // }
  formateDate(reservation: ReservationModel){
    const datepipe: DatePipe = new DatePipe('en-US');
    //z for local timezone
    let date = new Date((reservation.createDate as string)+"Z");
    let formattedDate = datepipe.transform(date, 'EE, d MMM, y | hh:mm a')
      if(formattedDate !== null) {
        reservation.createDate = formattedDate;
      }
  }
}
